import { Sport } from "sb-resp-lib";
import { Sport as SportSD } from "sbtech-sports-data-api-contracts";
import { SportModel } from "..";
import { sportDataMapper, SuitableSportFilter } from ".";

export class SportsMapper {
    sportDataMapper: sportDataMapper;

    constructor (sportDataMapper: sportDataMapper) {
        this.sportDataMapper = sportDataMapper;
    }

    map (sports?: Sport[]): SportModel[] {
        if (!sports || sports.length === 0)
        {
            return [];
        }

        const mappedResult = sports.map(this.sportDataMapper);
        const filteredResult = mappedResult.filter(x => x.order >= 0 && x.numberOfEvents !== 0 && SuitableSportFilter(x));
        return filteredResult;
    }

    mapFromPushes (sports?: SportSD[]): SportModel[] {
        if (!sports || sports.length === 0)
        {
            return [];
        }

        const mappedResult = sports.map(this.sportDataMapper);
        const filteredResult = mappedResult.filter(x => x.numberOfEvents !== 0 && SuitableSportFilter(x));
        return filteredResult;
    }
}